<template>
	<div>
		<v-row>
			<v-col cols="12">
				<v-data-table
				ref="dataTable"
				:headers="headers"
				:items="items"
				:loading-text="$t('wkt.admin.common.table.loading')"
				:no-data-text="$t('wkt.admin.common.table.no_data')"
				:no-results-text="$t('wkt.admin.common.table.no_results')"
				class="mt-4 elevation-0"
				fixedHeader
				hide-default-footer
				disable-pagination>
					<template v-slot:[`item`]="{ item }">
						<tr>
							<td>{{ formatLongDate(item.creationDate) }}</td>
							<td>{{ item.name }}</td>
							<td>{{ formatCurrency(item.amount) }}</td>
							<td>{{ item.projectName }}</td>
							<!--<td>
								<div v-if="item.approverId">
									<v-img max-width="38" max-height="38" :src="getProfileAssetUrl(item.approverProfilePicture)" style="float: left;"></v-img>
									<div style="margin-left: 43px;">
										<span class="truncate" style="display: block; white-space: nowrap;">{{ `${item.approverFirstname} ${item.approverLastname}` }}</span>
										<small style="display: block; white-space: nowrap; color: grey;">{{ formatLongDateTime(item.approvalDate) }}</small>
									</div>
								</div>
							</td>-->
							<td>
								<span class="truncate" :style="`display: block; white-space: nowrap; color: ${getStatusColor(item.status)}`">{{ getStatusText(item.status) }}</span>
							</td>
							<td>
								<v-btn text color="primary" class="text-button" @click="$emit('show-detail', item)">{{ $t('wkt.client.expensesheets.table.show_detail') }}</v-btn>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import BaseModule from '../../common/BaseModule.js'

export default {
	name: 'ExpenseSheetsTable',
	mixins: [BaseModule],
	props: ['headers','items'],
	components: {
	},
	data () {
		return {
		}
    },
	methods: {	
	},
	watch: {
		options: {
			handler () {
				this.$log.debug(this.options);
				this.$emit('refresh');
			},
			deep: true,
		},
	},
}
</script>

